module.exports = __webpack_public_path__ + "site/img/Maps_5KwunTong.86ba7091.jpg";